import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { UPDATE_PAGE_TITLE, UPDATE_PAGE_DESCRIPTION } from 'actions/actionTypes'

const usePageTitle = ({ view, detail, description = '' }) => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch({
      type: UPDATE_PAGE_TITLE,
      payload: {
        view,
        detail
      }
    })

    if (description) {
      dispatch({
        type: UPDATE_PAGE_DESCRIPTION,
        payload: {
          description
        }
      })
    }
  }, [dispatch, view, detail, description])
}

export default usePageTitle
